import React from 'react';
import { Header } from '../components/Header';
import { BuyVsRentCalculator } from '../components/BuyVsRentCalculator';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { CalcBreadcrumb, CalcRelatedLinks } from '../components/CalcBreadcrumb';

const BuyVsRentCalculatorPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      
      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12">
        <div className="container mx-auto px-4">
          <CalcBreadcrumb name="Buy Vs Rent Calculator" path="/calculators/buy-vs-rent" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 text-center leading-[1.1]">
            Buy Vs Rent <span className="text-emerald-600">Calculator</span>
          </h1>
          <p className="text-base sm:text-lg text-slate-600 text-center max-w-2xl mx-auto">
            Compare long-term wealth outcomes of buying versus renting
          </p>
          <CalcRelatedLinks links={[['Home Loan', '/home-loan'], ['Loan Against Property', '/loan-against-property']]} />
        </div>
      </div>

      <BuyVsRentCalculator />
      <Footer />
    </div>
  );
};

export default BuyVsRentCalculatorPage;
